export default {
    //defaultPath: '/dashboard/server',
    defaultPath: '/home',
    address: 'https://botspot.com.br',
    //address: 'http://127.0.0.1:80',
    alphat_auth: 'https://alphatrading.app/sign-in',
    alphat_payment: 'https://alphatrading.app/sign-in',
    basename: '/mintone/react/default', // only at build time to set, like ///mintone/react/default
    //basename: '/', // only at build time to set, like ///mintone/react/default
    layout: 'vertical', // vertical, horizontal
    collapseMenu: false, // mini-menu
    layoutType: 'menu-light', // menu-dark, menu-light
    headerBackColor: '', // header-blue, header-red, header-purple, header-info, header-dark
    fullWidthLayout: false,
    navFixedLayout: true,
    headerFixedLayout: true
};
